
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexAbRcGBCPVSKFbkwk22voOJAKXWck8YyWXAH3S5M2PDwMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/index.vue?macro=true";
import { default as indexX43OkvbnkQ3IXeB_PIlqOxIckgpP_GX9dUfwDR9xvJQMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/login/index.vue?macro=true";
import { default as index6F1X2Ezb_8Gn3QqsTMRN8r0o3OFtxYed41ER3mYkAuAMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/owner/[[id]]/online-booking/dsa/index.vue?macro=true";
import { default as index_46client9_sLUZeUJQBDh330LcOpER4kjwI13LqgPDlpY4X55S4Meta } from "/builds/escapadarural/rurality-nuxt/app/pages/owner/[[id]]/quality-rate/index.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/builds/escapadarural/rurality-nuxt/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as index_46clientgID7lqCmptS0tikcUyfIWLr2sAi3ALKwuaLP4s46h4sMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/owner/[[id]]/calendar/avaibook/index.client.vue?macro=true";
import { default as indexxFynZaVVfOz_LU6cLl4yIDH0e9p1AtBoOvezHV83rYoMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/owner/[[id]]/menu/services/legal-info/index.vue?macro=true";
import { default as index_46clientZPxj103yGJsoDFVx3NJnyX_q3YIc3umsAxBMBU_MpZUMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/owner/[[id]]/menu/services/dac7/index.client.vue?macro=true";
import { default as index_46client23Tlr78bV8gX3cckyWBS7vPKCwH1mFVqRObfPGQs__4Meta } from "/builds/escapadarural/rurality-nuxt/app/pages/owner/[[id]]/calendar/misterplan/index.client.vue?macro=true";
import { default as indexABRfP9i3_91EHpOsuSKswLYDNX72lxrEvMtfIlKJy4oMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/owner/[[id]]/menu/services/legal-info/edit/index.vue?macro=true";
import { default as index_46clientefKQtw6hcLuLPedTZBCdqyaNz0cz5QDTqEBlzknkfHgMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/owner/[[id]]/calendar/sync/[[rentUnitId]]/index.client.vue?macro=true";
import { default as indexzMFzyPRw1u7BlO3cn3m_wYONwosW_7XG7Ahgn8w3Tm8Meta } from "/builds/escapadarural/rurality-nuxt/app/pages/owner/[[id]]/menu/whatsapp/view/[type]/[idwhatsapp]/index.vue?macro=true";
import { default as index_46clientqNEqo97esBIxaWMZ06CqnM05xP_0jAMErXmCOYSx4N4Meta } from "/builds/escapadarural/rurality-nuxt/app/pages/owner/[[id]]/calendar/sync/[[rentUnitId]]/new/index.client.vue?macro=true";
import { default as _91_91id_93_93ew3PdiI0IT8mminfsYm1vo2F9QGQHuKDG7DqEJEO6IYMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/owner/[[id]].vue?macro=true";
import { default as indexDahtx9B3BGIImCu276fAnolN0sRSNqSqYpmdaoI_9pMMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/pueblos/index.vue?macro=true";
import { default as __links_46client4TNy7bUUvuyX2E_ACAod21ttXiOYRQkdJLiae22a7ZoMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/__links.client.vue?macro=true";
import { default as _91slug_93_REkzDeIG2ITEi7LU6yBVaiHICbvCNYg8Pp_tLtEqeQMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/campana/[slug].vue?macro=true";
import { default as indexBKQNIGf8ZZwQz2vas_kfJJ8ijxKHsEUCNAjOyDk2OgUMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/contacto/index.vue?macro=true";
import { default as indexqyVLfCLwTtUDSmdLnfa77U7RZ1ZFA0_85tGlqPJqxXcMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/escapadas/index.vue?macro=true";
import { default as index_46clientoiBDtxJkbztPVt3QMmqj7ipWPbF_j7nlhe532JXdhQwMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/traveler/[[id]]/menu/messages/index.client.vue?macro=true";
import { default as _91_91onlineBookingId_93_93_46clientBnqgR8KDOPibE42MqhpaTTzPo5E3uI9K_6spnSWnbd4Meta } from "/builds/escapadarural/rurality-nuxt/app/pages/traveler/[[id]]/online-booking/edit/[[onlineBookingId]].client.vue?macro=true";
import { default as _91_91onlineBookingId_93_93_46clienttUVxpDhRfeBNnsxDTX59uQzm1le9iafXaoImWWpn9ZQMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/traveler/[[id]]/online-booking/view/[[onlineBookingId]].client.vue?macro=true";
import { default as _91_91id_93_93_Maa_qB3r3KD2_ayfabYV_c4iHFKeMcqLvYQBeIruy8Meta } from "/builds/escapadarural/rurality-nuxt/app/pages/traveler/[[id]].vue?macro=true";
import { default as indexJv1LkC6nnQcB4HTqNrnD00PYy1cAPHF_PbqGcSAUm4gMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/signup-app/index.vue?macro=true";
import { default as indexUgH_88WLsW9FigxZlzuPUl3Eo4g4KfsUDQ2wGFLRoO4Meta } from "/builds/escapadarural/rurality-nuxt/app/pages/vacaciones/index.vue?macro=true";
import { default as hashtY39BAjmxmhG9FkFRSnNB4a7pmgtLPNM9_AgymZZDwgMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/__nuxt-pages/hash.vue?macro=true";
import { default as index3hhF__Udvzo_5KlNNFLRPMxQKRpzgJYT4uOeZcLsIBMMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/aviso-legal/index.vue?macro=true";
import { default as indexAc0OjrENw3jLpKPFD4k7HSil5NMrmHjs1aUmyXOMzhQMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/propietario/[[id]]/menu/invita-seleccion/index.vue?macro=true";
import { default as index_46clientF8yNbk_x7b5L5fUII8WPeMzv48jp0TOsHDr6xh46qToMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/propietario/[[id]]/casa/[cottageId]/legal/index.client.vue?macro=true";
import { default as index_46clientJJlWUFv_HWRnQO0n0mqrBveSrzPhTSW_GwMdZxGt7ssMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/propietario/[[id]]/casa/[cottageId]/editar/fotos/index.client.vue?macro=true";
import { default as _91_91id_93_936eKDSMljSfaEs4Azq2WcS9fix30yDoQLUdaECVaQI3cMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/propietario/[[id]].vue?macro=true";
import { default as healthAWZbQoa0xa7GcevREA8KGvz0DD_Sc0UqZ1NniRLcNU4Meta } from "/builds/escapadarural/rurality-nuxt/app/pages/__nuxt-pages/health.vue?macro=true";
import { default as index3yPKbY6Cyvpvm846OaguoBK9I3yAGb5w8orTgivtybkMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/accesibilidad/index.vue?macro=true";
import { default as index__THJg_VDEHpXhQvEexBvD1_I4hP9QxG8r4wawyMNkoMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/casas-rurales/index.vue?macro=true";
import { default as indexXih7ucJWAn0l2qbW8YWwXUKvF9tPFBc5XQjFHbmy_oAMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/pueblos/[slug]/index.vue?macro=true";
import { default as indexfcg41pLQD2fAt0vTavBABFFjSJsMUWqYOtHwJAoVOpQMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/destinos/[slug]/index.vue?macro=true";
import { default as indexrKyZqXaDoTiXgVhLviSHTFJDsAZ2kbsgrwSBcy6qmiwMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/escapadas/[slug]/index.vue?macro=true";
import { default as index9gHsl9RgFBS_479SRc9WMc1tY1Fco2T6NagThkblB2QMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/viajero/registro/index.vue?macro=true";
import { default as indexGynO2B1pj8iDNJr0fpSFAYFla_dKhaRbJaBtOLKwU0YMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/vacaciones/[slug]/index.vue?macro=true";
import { default as indexDfNHOqTE74fmVSePocHsUyGMOJpjdooa5VqgknodEgEMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/politica-privacidad/index.vue?macro=true";
import { default as indexImsgE0vNiirtBtmKQHNLlKyewIonDM4uAifgP9o1uoMMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/__nuxt-pages/design-system/index.vue?macro=true";
import { default as t_45prose_46client4cv6CgHVRZB4LOy6vrKAepCgiN3r8l_agXMY5BJ0QOEMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/__nuxt-pages/design-system/components/t-prose.client.vue?macro=true";
import { default as t_45title_46client9u8_trfatoKu_EK3AVip7BwBB7TggV_EZ5NwVOqlxf8Meta } from "/builds/escapadarural/rurality-nuxt/app/pages/__nuxt-pages/design-system/components/t-title.client.vue?macro=true";
import { default as s_45section_46clientXfFU4aCBzxWoHLT1ZePRxYr3K4fyIgaceXzl_ryAOzAMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/__nuxt-pages/design-system/sections/s-section.client.vue?macro=true";
import { default as s_45cta_45card_46client9EEyMdmgmOvqv1XiuqWj1JhNGIE8CWROeRshfD5yhWcMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/__nuxt-pages/design-system/sections/s-cta-card.client.vue?macro=true";
import { default as s_45hero_45card_46clientBcBj8sdaCxVBw6e5d8QqpWUPuy0qTWhzLLGKjU_yFvsMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/__nuxt-pages/design-system/sections/s-hero-card.client.vue?macro=true";
import { default as s_45hero_45angled_46client1IRaLQsHNWeuGsoQuo4Y20it2OxFup534RlfDaH1tXMMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/__nuxt-pages/design-system/sections/s-hero-angled.client.vue?macro=true";
import { default as t_45image_45info_46clientSz0LcOx1DJ_vbVDni2snoosRrwL7Vjl16Ji24EzFJ0EMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/__nuxt-pages/design-system/components/t-image-info.client.vue?macro=true";
import { default as s_45media_45banner_46clientuaFmB96xR5JgxQCchWRdXsQRGO1dcIlEeznPkGHpfRMMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/__nuxt-pages/design-system/sections/s-media-banner.client.vue?macro=true";
import { default as s_45section_45color_46client5UQBqcb4hlyyOXIWq0KyQWm5HqtbmeQII5XWp6MmcFoMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/__nuxt-pages/design-system/sections/s-section-color.client.vue?macro=true";
import { default as s_45section_45split_46client6OsEIcHjuRDdM7oJT9lZqLKLZljxZJkgRFgxQixiDd4Meta } from "/builds/escapadarural/rurality-nuxt/app/pages/__nuxt-pages/design-system/sections/s-section-split.client.vue?macro=true";
import { default as s_45simple_45banner_46clientAKqZiOQGj2MJdOwqzJcJSSexRteZHrC4EprBkppBQ8UMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/__nuxt-pages/design-system/sections/s-simple-banner.client.vue?macro=true";
import { default as s_45cta_45color_45image_46clienttzZUjCnlIV_no1vdWxT0Q4UERmjhGtj5LFZ_WrXSEb0Meta } from "/builds/escapadarural/rurality-nuxt/app/pages/__nuxt-pages/design-system/sections/s-cta-color-image.client.vue?macro=true";
import { default as s_45hero_45card_45search_46client9dN63VQDmmVO98gqvkpNNdjvPg9QPqg4Xcg7SQZGO44Meta } from "/builds/escapadarural/rurality-nuxt/app/pages/__nuxt-pages/design-system/sections/s-hero-card-search.client.vue?macro=true";
import { default as design_45systemSFAe5nhjoyPtSGcC_jkkcsCUQ8IDr5aQ9_NO4_sSbH0Meta } from "/builds/escapadarural/rurality-nuxt/app/pages/__nuxt-pages/design-system.vue?macro=true";
import { default as index_EcinYktopnWp_MAd9dytm0d_IO4nCru4dIMalDO1rIMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/aumenta-tus-reservas/index.vue?macro=true";
import { default as indexGjoYyyp5h7T2ERj7z2oj3_z7E8hjOk2yW4HEIQCnJwsMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/propietario/casa/nueva/index.vue?macro=true";
import { default as indexxR7_oyXQYZFFqefdtXa_JOjCjJFSx5m2zTm5QH1zbMkMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/viajero/registro-optin/index.vue?macro=true";
import { default as indexJsQoYxrOd_3RflqFtY0D3Ar6BStbla4pleHihX2Fs_gMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/aviso-legal-propietarios/index.vue?macro=true";
import { default as index0B0LEz3rpwtxmDbmGoNqwxrX459Yg8tUjdbZTrZNyfYMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/como-funciona-la-plataforma/index.vue?macro=true";
import { default as indexfifiVMPH7nygFqYboopenoMz8yay_XkcA6n4LQQGb_oMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/todas-las-escapadas-rurales/index.vue?macro=true";
import { default as indextRIykGY5UfYjmXZWJckLSG9oXvWLiHt5tMT2ewWVaD0Meta } from "/builds/escapadarural/rurality-nuxt/app/pages/casa-rural/[province]/[slug]/index.vue?macro=true";
import { default as index11T_tMPoL1bSkRlPqW4I4ccUJ0GaYS9JyPvy8nKs9dIMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/propietario/viajero-a-propietario/index.vue?macro=true";
import { default as index459j5YTa_FteyRuDte2Y2BVcnoucwLvAY3klGOg4LR8Meta } from "/builds/escapadarural/rurality-nuxt/app/pages/casa-rural/[province]/[slug]/precios/index.vue?macro=true";
import { default as indexir_NSaIOKkeU0ij8HywuR_ykYrHBCH4ER_d6TVTn_w8Meta } from "/builds/escapadarural/rurality-nuxt/app/pages/__nuxt-pages/cottages/recommended/[id]/index.vue?macro=true";
import { default as _91id_93QEluKeP_ZbfVLF_KQ97AfdOWpqsYi0feAzPxCQSMslAMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/casa-rural/[province]/[slug]/solicitud/oferta/[id].vue?macro=true";
import { default as indextNJPDUqSWFJKHuMFugQwtr5oJrG_vBaWfoZtFZ__QooMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/private/casa-rural/[province]/[slug]/telefono/index.vue?macro=true";
import { default as indexXTOYKNoXkQi4o4pcXn4rHeMtd8zSX7OlaaOrTUWQOg8Meta } from "/builds/escapadarural/rurality-nuxt/app/pages/__nuxt-pages/messages/whatsapp/[id]/[page]/[erck]/index.vue?macro=true";
import { default as indexqxYe_aFGqcK3HSka_dubuca1N9Xcc4TY25MEiiXbJt0Meta } from "/builds/escapadarural/rurality-nuxt/app/pages/casa-rural/[province]/[slug]/solicitud/pre-reserva/index.vue?macro=true";
import { default as indexY874AZKXAwf41ccdgva9o50oWsobm4J_vltZIRwskZYMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/casa-rural/[province]/[slug]/solicitud/contacto-email/index.vue?macro=true";
import { default as indexzPpWsf7k6zPYOeTx1MM_Mxw87lbTRZxVz8t0e_Qn_RoMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/casa-rural/[province]/[slug]/solicitud/contacto-whatsapp/index.vue?macro=true";
import { default as indexis_H6BBvXiwHuUcnzbchS3ieKh3b_5gR06_TKfeBN7YMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/casa-rural/[province]/[slug]/solicitud/online-booking/[id]/index.vue?macro=true";
import { default as indexQxz0TgDrVoCYMWI1OR48y_aed4Hq9vKbO_vun74vYyYMeta } from "/builds/escapadarural/rurality-nuxt/app/pages/casa-rural/[province]/[slug]/solicitud/online-booking/[id]/payment-success/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexAbRcGBCPVSKFbkwk22voOJAKXWck8YyWXAH3S5M2PDwMeta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: indexX43OkvbnkQ3IXeB_PIlqOxIckgpP_GX9dUfwDR9xvJQMeta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/login/index.vue")
  },
  {
    name: "owner-id",
    path: "/owner/:id?",
    meta: _91_91id_93_93ew3PdiI0IT8mminfsYm1vo2F9QGQHuKDG7DqEJEO6IYMeta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/owner/[[id]].vue"),
    children: [
  {
    name: "owner-id-online-booking-dsa",
    path: "online-booking/dsa",
    meta: index6F1X2Ezb_8Gn3QqsTMRN8r0o3OFtxYed41ER3mYkAuAMeta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/owner/[[id]]/online-booking/dsa/index.vue")
  },
  {
    name: "owner-id-quality-rate",
    path: "quality-rate",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/app/pages/owner/[[id]]/quality-rate/index.client.vue"))
  },
  {
    name: "owner-id-calendar-avaibook",
    path: "calendar/avaibook",
    meta: index_46clientgID7lqCmptS0tikcUyfIWLr2sAi3ALKwuaLP4s46h4sMeta || {},
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/app/pages/owner/[[id]]/calendar/avaibook/index.client.vue"))
  },
  {
    name: "owner-id-menu-services-legal-info",
    path: "menu/services/legal-info",
    meta: indexxFynZaVVfOz_LU6cLl4yIDH0e9p1AtBoOvezHV83rYoMeta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/owner/[[id]]/menu/services/legal-info/index.vue")
  },
  {
    name: "owner-id-menu-services-dac7",
    path: "menu/services/dac7",
    meta: index_46clientZPxj103yGJsoDFVx3NJnyX_q3YIc3umsAxBMBU_MpZUMeta || {},
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/app/pages/owner/[[id]]/menu/services/dac7/index.client.vue"))
  },
  {
    name: "owner-id-calendar-misterplan",
    path: "calendar/misterplan",
    meta: index_46client23Tlr78bV8gX3cckyWBS7vPKCwH1mFVqRObfPGQs__4Meta || {},
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/app/pages/owner/[[id]]/calendar/misterplan/index.client.vue"))
  },
  {
    name: "owner-id-menu-services-legal-info-edit",
    path: "menu/services/legal-info/edit",
    meta: indexABRfP9i3_91EHpOsuSKswLYDNX72lxrEvMtfIlKJy4oMeta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/owner/[[id]]/menu/services/legal-info/edit/index.vue")
  },
  {
    name: "owner-id-calendar-sync-rentUnitId",
    path: "calendar/sync/:rentUnitId?",
    meta: index_46clientefKQtw6hcLuLPedTZBCdqyaNz0cz5QDTqEBlzknkfHgMeta || {},
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/app/pages/owner/[[id]]/calendar/sync/[[rentUnitId]]/index.client.vue"))
  },
  {
    name: indexzMFzyPRw1u7BlO3cn3m_wYONwosW_7XG7Ahgn8w3Tm8Meta?.name ?? "owner-id-menu-whatsapp-view-type-idwhatsapp",
    path: "menu/whatsapp/view/:type()/:idwhatsapp()",
    meta: indexzMFzyPRw1u7BlO3cn3m_wYONwosW_7XG7Ahgn8w3Tm8Meta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/owner/[[id]]/menu/whatsapp/view/[type]/[idwhatsapp]/index.vue")
  },
  {
    name: "owner-id-calendar-sync-rentUnitId-new",
    path: "calendar/sync/:rentUnitId?/new",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/app/pages/owner/[[id]]/calendar/sync/[[rentUnitId]]/new/index.client.vue"))
  }
]
  },
  {
    name: "pueblos",
    path: "/pueblos",
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/pueblos/index.vue")
  },
  {
    name: "__links",
    path: "/__links",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/app/pages/__links.client.vue"))
  },
  {
    name: "campana-slug",
    path: "/campana/:slug()",
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/campana/[slug].vue")
  },
  {
    name: "contacto",
    path: "/contacto",
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/contacto/index.vue")
  },
  {
    name: "escapadas",
    path: "/escapadas",
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/escapadas/index.vue")
  },
  {
    name: "traveler-id",
    path: "/traveler/:id?",
    meta: _91_91id_93_93_Maa_qB3r3KD2_ayfabYV_c4iHFKeMcqLvYQBeIruy8Meta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/traveler/[[id]].vue"),
    children: [
  {
    name: "traveler-id-menu-messages",
    path: "menu/messages",
    meta: index_46clientoiBDtxJkbztPVt3QMmqj7ipWPbF_j7nlhe532JXdhQwMeta || {},
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/app/pages/traveler/[[id]]/menu/messages/index.client.vue"))
  },
  {
    name: "traveler-id-online-booking-edit-onlineBookingId",
    path: "online-booking/edit/:onlineBookingId?",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/app/pages/traveler/[[id]]/online-booking/edit/[[onlineBookingId]].client.vue"))
  },
  {
    name: "traveler-id-online-booking-view-onlineBookingId",
    path: "online-booking/view/:onlineBookingId?",
    meta: _91_91onlineBookingId_93_93_46clienttUVxpDhRfeBNnsxDTX59uQzm1le9iafXaoImWWpn9ZQMeta || {},
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/app/pages/traveler/[[id]]/online-booking/view/[[onlineBookingId]].client.vue"))
  }
]
  },
  {
    name: "signup-app",
    path: "/signup-app",
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/signup-app/index.vue")
  },
  {
    name: "vacaciones",
    path: "/vacaciones",
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/vacaciones/index.vue")
  },
  {
    name: "__nuxt-pages-hash",
    path: "/__nuxt-pages/hash",
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/__nuxt-pages/hash.vue")
  },
  {
    name: "aviso-legal",
    path: "/aviso-legal",
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/aviso-legal/index.vue")
  },
  {
    name: "propietario-id",
    path: "/propietario/:id?",
    meta: _91_91id_93_936eKDSMljSfaEs4Azq2WcS9fix30yDoQLUdaECVaQI3cMeta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/propietario/[[id]].vue"),
    children: [
  {
    name: "propietario-id-menu-invita-seleccion",
    path: "menu/invita-seleccion",
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/propietario/[[id]]/menu/invita-seleccion/index.vue")
  },
  {
    name: "propietario-id-casa-cottageId-legal",
    path: "casa/:cottageId()/legal",
    meta: index_46clientF8yNbk_x7b5L5fUII8WPeMzv48jp0TOsHDr6xh46qToMeta || {},
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/app/pages/propietario/[[id]]/casa/[cottageId]/legal/index.client.vue"))
  },
  {
    name: "propietario-id-casa-cottageId-editar-fotos",
    path: "casa/:cottageId()/editar/fotos",
    meta: index_46clientJJlWUFv_HWRnQO0n0mqrBveSrzPhTSW_GwMdZxGt7ssMeta || {},
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/app/pages/propietario/[[id]]/casa/[cottageId]/editar/fotos/index.client.vue"))
  }
]
  },
  {
    name: "__nuxt-pages-health",
    path: "/__nuxt-pages/health",
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/__nuxt-pages/health.vue")
  },
  {
    name: "accesibilidad",
    path: "/accesibilidad",
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/accesibilidad/index.vue")
  },
  {
    name: "casas-rurales",
    path: "/casas-rurales",
    meta: index__THJg_VDEHpXhQvEexBvD1_I4hP9QxG8r4wawyMNkoMeta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/casas-rurales/index.vue")
  },
  {
    name: "pueblos-slug",
    path: "/pueblos/:slug()",
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/pueblos/[slug]/index.vue")
  },
  {
    name: "destinos-slug",
    path: "/destinos/:slug()",
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/destinos/[slug]/index.vue")
  },
  {
    name: "escapadas-slug",
    path: "/escapadas/:slug()",
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/escapadas/[slug]/index.vue")
  },
  {
    name: "viajero-registro",
    path: "/viajero/registro",
    meta: index9gHsl9RgFBS_479SRc9WMc1tY1Fco2T6NagThkblB2QMeta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/viajero/registro/index.vue")
  },
  {
    name: "vacaciones-slug",
    path: "/vacaciones/:slug()",
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/vacaciones/[slug]/index.vue")
  },
  {
    name: "politica-privacidad",
    path: "/politica-privacidad",
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/politica-privacidad/index.vue")
  },
  {
    name: design_45systemSFAe5nhjoyPtSGcC_jkkcsCUQ8IDr5aQ9_NO4_sSbH0Meta?.name,
    path: "/__nuxt-pages/design-system",
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/__nuxt-pages/design-system.vue"),
    children: [
  {
    name: "__nuxt-pages-design-system",
    path: "",
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/__nuxt-pages/design-system/index.vue")
  },
  {
    name: "__nuxt-pages-design-system-components-t-prose",
    path: "components/t-prose",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/app/pages/__nuxt-pages/design-system/components/t-prose.client.vue"))
  },
  {
    name: "__nuxt-pages-design-system-components-t-title",
    path: "components/t-title",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/app/pages/__nuxt-pages/design-system/components/t-title.client.vue"))
  },
  {
    name: "__nuxt-pages-design-system-sections-s-section",
    path: "sections/s-section",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/app/pages/__nuxt-pages/design-system/sections/s-section.client.vue"))
  },
  {
    name: "__nuxt-pages-design-system-sections-s-cta-card",
    path: "sections/s-cta-card",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/app/pages/__nuxt-pages/design-system/sections/s-cta-card.client.vue"))
  },
  {
    name: "__nuxt-pages-design-system-sections-s-hero-card",
    path: "sections/s-hero-card",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/app/pages/__nuxt-pages/design-system/sections/s-hero-card.client.vue"))
  },
  {
    name: "__nuxt-pages-design-system-sections-s-hero-angled",
    path: "sections/s-hero-angled",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/app/pages/__nuxt-pages/design-system/sections/s-hero-angled.client.vue"))
  },
  {
    name: "__nuxt-pages-design-system-components-t-image-info",
    path: "components/t-image-info",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/app/pages/__nuxt-pages/design-system/components/t-image-info.client.vue"))
  },
  {
    name: "__nuxt-pages-design-system-sections-s-media-banner",
    path: "sections/s-media-banner",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/app/pages/__nuxt-pages/design-system/sections/s-media-banner.client.vue"))
  },
  {
    name: "__nuxt-pages-design-system-sections-s-section-color",
    path: "sections/s-section-color",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/app/pages/__nuxt-pages/design-system/sections/s-section-color.client.vue"))
  },
  {
    name: "__nuxt-pages-design-system-sections-s-section-split",
    path: "sections/s-section-split",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/app/pages/__nuxt-pages/design-system/sections/s-section-split.client.vue"))
  },
  {
    name: "__nuxt-pages-design-system-sections-s-simple-banner",
    path: "sections/s-simple-banner",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/app/pages/__nuxt-pages/design-system/sections/s-simple-banner.client.vue"))
  },
  {
    name: "__nuxt-pages-design-system-sections-s-cta-color-image",
    path: "sections/s-cta-color-image",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/app/pages/__nuxt-pages/design-system/sections/s-cta-color-image.client.vue"))
  },
  {
    name: "__nuxt-pages-design-system-sections-s-hero-card-search",
    path: "sections/s-hero-card-search",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/app/pages/__nuxt-pages/design-system/sections/s-hero-card-search.client.vue"))
  }
]
  },
  {
    name: "aumenta-tus-reservas",
    path: "/aumenta-tus-reservas",
    meta: index_EcinYktopnWp_MAd9dytm0d_IO4nCru4dIMalDO1rIMeta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/aumenta-tus-reservas/index.vue")
  },
  {
    name: "propietario-casa-nueva",
    path: "/propietario/casa/nueva",
    meta: indexGjoYyyp5h7T2ERj7z2oj3_z7E8hjOk2yW4HEIQCnJwsMeta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/propietario/casa/nueva/index.vue")
  },
  {
    name: "viajero-registro-optin",
    path: "/viajero/registro-optin",
    meta: indexxR7_oyXQYZFFqefdtXa_JOjCjJFSx5m2zTm5QH1zbMkMeta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/viajero/registro-optin/index.vue")
  },
  {
    name: "aviso-legal-propietarios",
    path: "/aviso-legal-propietarios",
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/aviso-legal-propietarios/index.vue")
  },
  {
    name: "como-funciona-la-plataforma",
    path: "/como-funciona-la-plataforma",
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/como-funciona-la-plataforma/index.vue")
  },
  {
    name: "todas-las-escapadas-rurales",
    path: "/todas-las-escapadas-rurales",
    meta: indexfifiVMPH7nygFqYboopenoMz8yay_XkcA6n4LQQGb_oMeta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/todas-las-escapadas-rurales/index.vue")
  },
  {
    name: "casa-rural-province-slug",
    path: "/casa-rural/:province()/:slug()",
    meta: indextRIykGY5UfYjmXZWJckLSG9oXvWLiHt5tMT2ewWVaD0Meta || {},
    alias: indextRIykGY5UfYjmXZWJckLSG9oXvWLiHt5tMT2ewWVaD0Meta?.alias || [],
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/casa-rural/[province]/[slug]/index.vue")
  },
  {
    name: "propietario-viajero-a-propietario",
    path: "/propietario/viajero-a-propietario",
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/propietario/viajero-a-propietario/index.vue")
  },
  {
    name: "casa-rural-province-slug-precios",
    path: "/casa-rural/:province()/:slug()/precios",
    alias: index459j5YTa_FteyRuDte2Y2BVcnoucwLvAY3klGOg4LR8Meta?.alias || [],
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/casa-rural/[province]/[slug]/precios/index.vue")
  },
  {
    name: "__nuxt-pages-cottages-recommended-id",
    path: "/__nuxt-pages/cottages/recommended/:id()",
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/__nuxt-pages/cottages/recommended/[id]/index.vue")
  },
  {
    name: "casa-rural-province-slug-solicitud-oferta-id",
    path: "/casa-rural/:province()/:slug()/solicitud/oferta/:id()",
    meta: _91id_93QEluKeP_ZbfVLF_KQ97AfdOWpqsYi0feAzPxCQSMslAMeta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/casa-rural/[province]/[slug]/solicitud/oferta/[id].vue")
  },
  {
    name: "private-casa-rural-province-slug-telefono",
    path: "/private/casa-rural/:province()/:slug()/telefono",
    meta: indextNJPDUqSWFJKHuMFugQwtr5oJrG_vBaWfoZtFZ__QooMeta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/private/casa-rural/[province]/[slug]/telefono/index.vue")
  },
  {
    name: indexXTOYKNoXkQi4o4pcXn4rHeMtd8zSX7OlaaOrTUWQOg8Meta?.name ?? "__nuxt-pages-messages-whatsapp-id-page-erck",
    path: "/__nuxt-pages/messages/whatsapp/:id()/:page()/:erck()",
    meta: indexXTOYKNoXkQi4o4pcXn4rHeMtd8zSX7OlaaOrTUWQOg8Meta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/__nuxt-pages/messages/whatsapp/[id]/[page]/[erck]/index.vue")
  },
  {
    name: "casa-rural-province-slug-solicitud-pre-reserva",
    path: "/casa-rural/:province()/:slug()/solicitud/pre-reserva",
    meta: indexqxYe_aFGqcK3HSka_dubuca1N9Xcc4TY25MEiiXbJt0Meta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/casa-rural/[province]/[slug]/solicitud/pre-reserva/index.vue")
  },
  {
    name: indexY874AZKXAwf41ccdgva9o50oWsobm4J_vltZIRwskZYMeta?.name ?? "casa-rural-province-slug-solicitud-contacto-email",
    path: "/casa-rural/:province()/:slug()/solicitud/contacto-email",
    meta: indexY874AZKXAwf41ccdgva9o50oWsobm4J_vltZIRwskZYMeta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/casa-rural/[province]/[slug]/solicitud/contacto-email/index.vue")
  },
  {
    name: "casa-rural-province-slug-solicitud-contacto-whatsapp",
    path: "/casa-rural/:province()/:slug()/solicitud/contacto-whatsapp",
    meta: indexzPpWsf7k6zPYOeTx1MM_Mxw87lbTRZxVz8t0e_Qn_RoMeta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/casa-rural/[province]/[slug]/solicitud/contacto-whatsapp/index.vue")
  },
  {
    name: "casa-rural-province-slug-solicitud-online-booking-id",
    path: "/casa-rural/:province()/:slug()/solicitud/online-booking/:id()",
    meta: indexis_H6BBvXiwHuUcnzbchS3ieKh3b_5gR06_TKfeBN7YMeta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/casa-rural/[province]/[slug]/solicitud/online-booking/[id]/index.vue")
  },
  {
    name: "casa-rural-province-slug-solicitud-online-booking-id-payment-success",
    path: "/casa-rural/:province()/:slug()/solicitud/online-booking/:id()/payment-success",
    meta: indexQxz0TgDrVoCYMWI1OR48y_aed4Hq9vKbO_vun74vYyYMeta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/app/pages/casa-rural/[province]/[slug]/solicitud/online-booking/[id]/payment-success/index.vue")
  }
]